import React from "react";
import { ThemeProvider } from "@emotion/react";

import { Theme } from "components";

const ColorMode = ({ children, mode }) => {
  const colors = Theme.colors.modes?.[mode] ?? Theme.colors;

  return <ThemeProvider theme={{ ...Theme, colors }}>{children}</ThemeProvider>;
};

export default ColorMode;
